import { createContext, useContext } from 'react';

import { DEFAULT_LOCALE, type Locale } from './locales';

const LocaleContext = createContext<Locale>(DEFAULT_LOCALE);

export const LocaleProvider = LocaleContext.Provider;

/**
 * The locale of the active route tree.
 *
 * Read this rather than `i18n.language`: the URL is the source of truth, and it
 * is already correct on the very first render, before the effect that syncs
 * i18next has had a chance to run.
 */
export function useLocale(): Locale {
  return useContext(LocaleContext);
}
